import { AnchorHTMLAttributes } from "react";
import { Link, LinkProps } from "react-router-dom";
import {
  getButtonClassName,
  type ButtonSize,
  type ButtonVariant,
} from "@/components/UI/buttonStyles";
import "./Button.css";

interface ButtonLinkProps extends LinkProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export interface ButtonAnchorProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export function ButtonLink({
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...rest
}: ButtonLinkProps) {
  return (
    <Link className={getButtonClassName({ className, size, variant })} {...rest}>
      {children}
    </Link>
  );
}

export function ButtonAnchor({
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...rest
}: ButtonAnchorProps) {
  return (
    <a className={getButtonClassName({ className, size, variant })} {...rest}>
      {children}
    </a>
  );
}
